module.exports = __webpack_public_path__ + "img/japan.8e69fa7d.png";